import React from "react";
import { Box, Typography } from "@mui/material";

// Shared height so pills (Assignee/Status/Reviewer) line up with inputs/selects.
export const FIELD_HEIGHT = 40;

/**
 * Consistent top-aligned field label with an optional required marker.
 */
export const FieldLabel = ({ children, required = false }) => (
  <Typography
    component="label"
    variant="caption"
    sx={{
      display: "block",
      mb: 0.5,
      fontWeight: 600,
      color: "text.secondary",
      lineHeight: 1.2,
    }}
  >
    {children}
    {required && (
      <Box component="span" sx={{ color: "error.main", ml: 0.25 }}>
        *
      </Box>
    )}
  </Typography>
);

/**
 * Subtle titled card used to visually group related fields.
 */
export const FormSection = ({ title, children, sx }) => (
  <Box
    sx={{
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      p: 1.5,
      ...sx,
    }}
  >
    <Typography
      variant="overline"
      sx={{
        display: "block",
        fontWeight: 700,
        color: "text.secondary",
        letterSpacing: 0.6,
        mb: 1,
        lineHeight: 1.4,
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);
